<template>
  <w-settings-content-template>
    <el-tabs slot="content" type="card" v-model="activeTab">
      <el-tab-pane label="관리대상 등록" name="WE2eDeviceRegistration" class="h100 w100">
        <w-e2e-device-registration :agentData="agentData"></w-e2e-device-registration>
      </el-tab-pane>
      <el-tab-pane label="E2E 에이전트 리스트" name="WE2eAgentList" class="h100 w100">
        <w-e2e-agent-list @setAgentData="setAgentData"></w-e2e-agent-list>
      </el-tab-pane>
    </el-tabs>
</w-settings-content-template>

</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WE2eAgentList from './E2eAgentList';
import WE2eDeviceRegistration from './E2eDeviceRegistration';

export default {
  name: 'WE2EDevice',
  components: {
    WSettingsContentTemplate,
    WE2eAgentList,
    WE2eDeviceRegistration,
  },
  data() {
    return {
      activeTab: 'WE2eDeviceRegistration',
      agentData: [],
    };
  },
  methods: {
    setAgentData(agentData) {
      this.agentData = agentData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/index.vue